<template>
    <div class="fleet-settings">
        <div class="fleet-settings__side-menu">
            <side-menu
                :links="links"
            ></side-menu>
        </div>
        <div class="fleet-settings__content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>

import SideMenu from '@/components/layout/SideMenu/SideMenu'
import SideMenuObject from '@/components/layout/SideMenu/SideMenuItemObject'

export default {
    name: 'FleetSettingsBase',
    components: {
        SideMenu
    },
    data () {
        return {
            links: [
                new SideMenuObject('info-circle-solid', 'Details', 'router', 'editFleetDetails', this.hasAllRoles(['FleetView'])),
                new SideMenuObject('cogs-solid', 'Edit Thresholds', 'router', 'fleetThresholdSettings', this.hasAllRoles(['FleetView'])),
                new SideMenuObject('envelope-regular', 'Notifications', 'router', 'fleetNotificationSettings', this.hasAllRoles(['FleetView'])),
                new SideMenuObject('diagram-solid', 'Alarm Pipelines', 'router', 'fleetAlarmPipelines', this.hasAllRoles(['FleetView']))
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.fleet-settings {
    display: flex;
    height: 100%;
    min-height: calc(100vh - 80px);
    &__side-menu {
        border-left: 16px solid $primary;
        background: $secondary;
    }
    &__content {
        position: relative;
        width: calc(100% - 165px);
        padding: 15px;
    }
}
</style>
